import { useEffect, useRef, useState } from 'react'

import { getItemsIds } from '../../../../../../utils/common'
import { isPhaseCompleted } from '../../../RequestProfileTabActivities.utils'

export function useOpenPhaseIds(phases) {
  const [openPhaseIds, setOpenPhaseIds] = useState(() => new Set())

  const knownPhaseIdsRef = useRef(null)

  useEffect(() => {
    if (phases?.length > 0) {
      const knownPhaseIds = knownPhaseIdsRef.current

      const appearedPhases = knownPhaseIds
        ? phases.filter(phase => !knownPhaseIds.has(phase.id))
        : phases

      const openIds = getItemsIds(
        appearedPhases.filter(phase => !isPhaseCompleted(phase))
      )

      if (openIds.length > 0) {
        setOpenPhaseIds(prev => new Set([...prev, ...openIds]))
      }

      knownPhaseIdsRef.current = new Set(getItemsIds(phases))
    }
  }, [phases])

  function handleToggleOpen(phaseId) {
    setOpenPhaseIds(prev => {
      const next = new Set(prev)

      if (next.has(phaseId)) {
        next.delete(phaseId)
      } else {
        next.add(phaseId)
      }

      return next
    })
  }

  function handleOpen(index) {
    const phaseId = phases?.[index]?.id

    if (phaseId) {
      setOpenPhaseIds(prev => {
        const next = new Set(prev)

        next.add(phaseId)

        return next
      })
    }
  }

  return { handleOpen, handleToggleOpen, openPhaseIds }
}
